import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCHeaderOnboardingComponent = class UiCHeaderOnboardingComponent {
    constructor() {
        this.isBack = true;
        this.isText = true;
        this.isPartner = true;
        this.back = new EventEmitter();
    }
    goBack() {
        this.back.emit();
    }
    isMobile() {
        if (window.innerWidth < 750) {
            return true;
        }
        else {
            return false;
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "companyName", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "document", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "textBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCHeaderOnboardingComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCHeaderOnboardingComponent.prototype, "isText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCHeaderOnboardingComponent.prototype, "isPartner", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "identifier", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCHeaderOnboardingComponent.prototype, "secondaryColor", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCHeaderOnboardingComponent.prototype, "back", void 0);
UiCHeaderOnboardingComponent = __decorate([
    Component({
        selector: 'ui-c-header-onboarding',
        template: "<ion-row class=\"ion-margin-bottom\" *ngIf=\"isBack\">\n  <ion-fab-button class=\"ion-fab-button ion-margin\" (click)=\"goBack()\">\n    <ion-icon class=\"ion-icon\" name=\"chevron-back-outline\"></ion-icon>\n  </ion-fab-button>\n    <span class=\"color-primary d-flex justify-content-center align-items-center font-size-18 font-family-semibold\" [style.color]=\"'#fff'\"> {{ 'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\n    }}</span>\n</ion-row>\n\n<h2 class=\"ion-text-left\" *ngIf=\"isText\">\n  <span *ngIf=\"!isPartner\" class=\"color-primary font-family-bold font-size-28\" [style.color]=\"primaryColor\">\n    {{ identifier | wlpTranslate }}{{ name }}\n  </span>\n  <br *ngIf=\"!isPartner\">\n  <span *ngIf=\"!isPartner\" class=\"color-primary font-family-bold font-size-28\" [style.color]=\"primaryColor\">\n    {{ 'ONBORDING.V2.FORM.LABEL.COMPANY' | wlpTranslate }}{{ companyName }} - {{ document }}\n  </span>\n  <br *ngIf=\"!isPartner\">\n  <br *ngIf=\"!isPartner\">\n  <span *ngIf=\"!isMobile()\" class=\"color-primary font-family-bold font-size-40\" [style.color]=\"primaryColor\">{{ title }}</span>\n  <!-- mobile -->\n  <span *ngIf=\"isMobile()\" class=\"color-primary font-family-bold font-size-27\" [style.color]=\"primaryColor\">{{ title }}</span>\n  <!-- mobile fim -->\n  <br>\n  <span *ngIf=\"!isMobile()\" class=\"color-secondary font-family-semibold font-size-32\" [style.color]=\"secondaryColor\">\n    {{ description }}\n  </span>\n\n  <!-- mobile -->\n  <span *ngIf=\"isMobile()\" class=\"color-secondary font-family-semibold font-size-19\" [style.color]=\"secondaryColor\">\n    {{ description }}\n  </span>\n  <!-- mobile fim -->\n</h2>\n"
    }),
    __metadata("design:paramtypes", [])
], UiCHeaderOnboardingComponent);

let UiCHeaderOnboardingModule = class UiCHeaderOnboardingModule {
};
UiCHeaderOnboardingModule = __decorate([
    NgModule({
        declarations: [UiCHeaderOnboardingComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCHeaderOnboardingComponent]
    })
], UiCHeaderOnboardingModule);

export { UiCHeaderOnboardingComponent, UiCHeaderOnboardingModule };
//# sourceMappingURL=wlp-ui-c-header-onboarding.js.map
